function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e89a4f;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5716\\u5C64_2",
  "data-name": "\\u5716\\u5C64 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M75.86,182.21c16-1.57,32.41-7.29,48.23-8.42,54.63-3.9,105.15,16.64,133.17,65,12.31,21.24,34.32,51.06,62.61,46.5,16.86-2.72,33.36-21.34,46.15-32.95C398.3,223,425.2,161.33,406.36,119c-10.52-23.63-29.72-42.79-52.81-54.23C329,52.6,298.87,56.89,273,47.89c-52-18.06-106.19-59.17-164-45C81.45,9.7,76.26,20.85,64,43,57.16,55.19,49.71,69.2,38.37,77.89,19,92.75.52,99.83,0,128.72s36.05,50.54,61.12,53.5A68.43,68.43,0,0,0,75.86,182.21Z"
}));

function SvgBackgroundY1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 412.59 285.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundY1);
export default __webpack_public_path__ + "static/media/background-y-1.2bfdaef1.svg";
export { ForwardRef as ReactComponent };